import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { ServiciiComponent } from './servicii.component';
import { AddServiciiComponent } from './add-servicii/add-servicii.component';
import { EditServiciiComponent } from './edit-servicii/edit-servicii.component';

@NgModule({
    declarations: [
        ServiciiComponent,
        AddServiciiComponent,
        EditServiciiComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [ServiciiComponent]
})
export class ServiciiModule { }
